import { render, staticRenderFns } from "./usappbypm.vue?vue&type=template&id=51f2123b&scoped=true&"
import script from "./usappbypm.vue?vue&type=script&lang=js&"
export * from "./usappbypm.vue?vue&type=script&lang=js&"
import style0 from "./usappbypm.vue?vue&type=style&index=0&id=51f2123b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51f2123b",
  null
  
)

export default component.exports